<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Выгрузка файлов</template>
        <template #content>
          <form @submit.prevent="onSubmit">
            <div class="p-fluid col-12 md:col-6">
              <div class="field">
                <label class="font-bold">Номер займа, УИД ЦБ, УИД Заявки</label>
                <small class="text-gray-500">Для выгрузки по удаленным займам воспользуйтесь УИД ЦБ или УИД Заявки</small>
                <Textarea
                    v-model="identifiersText"
                    auto-resize
                    rows="5"
                    placeholder="Введите идентификаторы"
                    :disabled="loading"
                />
              </div>

              <div class="field">
                <label class="font-bold">Почта для отправки результата</label>
                <InputText v-model="email" required :disabled="loading"></InputText>
              </div>

              <div class="row">
                <div class="col-12 p-0 mt-2 mb-2">
                  <Checkbox
                      binary
                      inputId="splitEventsByFolders"
                      v-model="splitEventsByFolders"
                      :disabled="loading"
                  />
                  <label class="font-bold ml-1" for="splitEventsByFolders">
                    Разбить события по папкам
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-12 p-0 mt-2 mb-2">
                  <Checkbox
                      binary
                      inputId="exportAsSingleFile"
                      v-model="exportAsSingleFile"
                      :disabled="loading"
                  />
                  <label class="font-bold ml-1" for="exportAsSingleFile">
                    Выгрузка данных одним файлом (кроме удаления КИ)
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-5 p-0">
                  <Button
                      type="submit"
                      class="p-button-success"
                      label="Отправить"
                      :loading="loading"
                  ></Button>
                </div>
              </div>
            </div>
          </form>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import Checkbox from 'primevue/checkbox'
import FunctionsService from "@/service/FunctionsService";

export default {
  name: "ExportFiles",
  components: { Checkbox },
  data() {
    return {
      identifiersText: '',
      email: null,
      splitEventsByFolders: false,
      exportAsSingleFile: false,
      loading: false,
    }
  },
  watch: {
    splitEventsByFolders(val) {
      if (val) this.exportAsSingleFile = false
    },
    exportAsSingleFile(val) {
      if (val) this.splitEventsByFolders = false
    },
  },
  methods: {
    onSubmit() {
      const identifiers = this.identifiersText
          .split(/[\n,\s]+/)
          .map(s => s.trim())
          .filter(s => s !== '')

      if (identifiers.length === 0) {
        this.$toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Введите хотя бы один идентификатор',
          life: 3000
        })
        return
      }

      if (!this.email) {
        this.$toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Укажите email для отправки результата',
          life: 3000
        })
        return
      }

      this.loading = true

      FunctionsService.exportFiles(
          identifiers,
          this.splitEventsByFolders,
          this.exportAsSingleFile,
          this.email,
      ).then((res) => {
        this.$toast.add({
          severity: 'success',
          summary: 'Успех',
          detail: res.message,
          life: 5000
        })
      }).catch((err) => {
        this.$toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: typeof err.data === 'string' ? err.data : (err.message || 'Внутренняя ошибка обработки'),
          life: 4000
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>